import React from 'react';
import AdminFilters from './AdminFilters';
import { EmptyState } from '../common';
import { formatDate } from '../../utils/formatters';
import { AD_STATUSES, AD_TARGET_PAGES } from '../../constants/admin';
import api from '../../services/api';

const targetPageLabel = (value) => {
  const found = AD_TARGET_PAGES.find(t => t.value === value);
  return found ? found.label : value || '-';
};

const AdminAdsTab = ({
  ads,
  loading,
  filters,
  setFilters,
  onSearch,
  onEdit,
  onDelete,
  onCreate
}) => {
  const handleExport = async () => {
    try {
      const params = new URLSearchParams();
      if (filters.status) params.append('status', filters.status);
      if (filters.search) params.append('search', filters.search);

      const response = await api.get(`/admin/ads/export?${params.toString()}`, {
        responseType: 'blob'
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'ads_export.csv');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Export failed:', err);
    }
  };

  const renderContent = () => {
    if (loading) {
      return <div className="loading">Loading...</div>;
    }

    if (ads.length === 0) {
      return (
        <EmptyState
          icon="📢"
          title="No ads found"
          message={filters.search || filters.status
            ? 'No ads match your current filters. Try adjusting your search criteria.'
            : 'No advertisements have been created yet.'}
        />
      );
    }

    return (
      <div className="admin-table-wrapper">
        <table className="admin-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Title</th>
              <th>Target Pages</th>
              <th>Position</th>
              <th>Status</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Created By</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {ads.map(ad => (
              <tr key={ad.id}>
                <td>{ad.id}</td>
                <td>{ad.title}</td>
                <td>{targetPageLabel(ad.target_pages)}</td>
                <td>{ad.display_frequency}</td>
                <td>
                  <span className={`status-badge ${ad.status}`}>
                    {ad.status}
                  </span>
                </td>
                <td>{ad.start_date ? formatDate(ad.start_date) : '-'}</td>
                <td>{ad.end_date ? formatDate(ad.end_date) : '-'}</td>
                <td>{ad.created_by_name || ad.created_by || '-'}</td>
                <td className="actions">
                  <button className="btn-edit" onClick={() => onEdit(ad)}>Edit</button>
                  <button className="btn-delete" onClick={() => onDelete(ad.id)}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <>
      <div className="admin-actions-bar">
        <AdminFilters
          filters={filters}
          setFilters={setFilters}
          onSearch={onSearch}
          searchPlaceholder="Search by title..."
          filterOptions={AD_STATUSES}
          filterKey="status"
          filterPlaceholder="All Statuses"
        />
        <button className="btn-create" onClick={onCreate}>
          Create Ad
        </button>
        <button className="btn-export" onClick={handleExport}>
          Export CSV
        </button>
      </div>
      {renderContent()}
    </>
  );
};

export default AdminAdsTab;
